import { MembersService, FetchingError } from '@/services/members.service'
// import router from '@/router';

const state = {
    fetching: true,
    uploading: false,
    members: {},
    member: {},
    fetchingErrorCode: 0,
    fetchingError: '',
}

const getters = {
    
    fetchingErrorCode: (state) => {
        return state.fetchingErrorCode
    },

    fetchingError: (state) => {
        return state.fetchingError
    },

    fetching: (state) => {
        return state.fetching
    },

    uploading: (state) => {
        return state.uploading
    },

    members: (state) => {
        return state.members;
    },

    member: (state) => {
        return state.member;
    },
}

const actions = {
    async fetchMembers({commit}) {
        
        commit('fetchMembersRequest');

        try {
            const members = await MembersService.fetchMembers();
            commit('fetchingMembersSuccess', members)

            // router.push(router.history.current.query.redirect || '/');

            return true
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', {errorCode: e.errorCode, errorMessage: e.message})
            }

            return false
        }
    },
    async fetchMember({ commit }, member_id) {
        commit('fetchMemberRequest');

        try {
            const member = await MembersService.fetchMember(member_id);
            // console.log(member)
            commit('fetchingMemberSuccess', member)

            return true
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }

            return false
        }
    },
    async saveMember({ commit }, { data }) {
        commit('saveMemberRequest');

        try {
            const member = await MembersService.saveMember(data);
            commit('saveMemberSuccess', member)

            return true
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }

            return false
        }
    },
    async uploadUserImage({ commit }, { data }) {
        commit('uploadImageRequest');
        try {
            const member = await MembersService.uploadUserImage(data);
            commit('uploadImageSuccess', member)

            return true
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }

            return false
        }
    },
}

const mutations = {
    fetchMembersRequest(state) {
        state.fetching = true,
        state.fetchingError = '',
        state.fetchingErrorCode = 0
    },

    fetchingMembersSuccess(state, members) {
        state.members = members;
        state.fetching = false;
    },

    fetchMemberRequest(state) {
        state.member = {},
        state.fetching = true,
        state.fetchingError = '',
        state.fetchingErrorCode = 0
    },

    fetchingMemberSuccess(state, member) {
        if (typeof member.fe_user_roles !== 'undefined' && member.fe_user_roles.length > 0) {
            member.fe_user_roles = member.fe_user_roles.map(role => {
                role = role.ID;
                return role;
            });
        }

        state.member = member;
        state.fetching = false;
    },

    fetchingError(state, {errorCode, errorMessage}) {
        state.fetching = false
        state.fetchingErrorCode = errorCode
        state.fetchingError = errorMessage
    },

    saveMemberRequest(state) {
        state.fetching = true,
        state.fetchingError = '',
        state.fetchingErrorCode = 0
    },

    saveMemberSuccess(state, member) {
        state.member = member;
        state.fetching = false;
        window.LC_Event.$emit('saveMemberSuccess', event);
    },

    uploadImageRequest(state) {
        state.uploading = true,
        state.fetchingError = '',
        state.fetchingErrorCode = 0
    },

    uploadImageSuccess(state, member) {
        state.member = member;
        state.uploading = false;
    },
}

// export const auth = {
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}